import './Blank.css'

export default function Blank() {
  return (
    <div className='Blank'>
      {/* <h4 className='w-100'>LOADING...</h4> */}
    </div>
  )
}
